import { PropTypes, describe } from '../../propTypes/index.ts';

const TestSchema = {
  string: PropTypes.string.description('String'),
  number: PropTypes.number.description('Number'),
  boolean: PropTypes.bool.description('Boolean'),
  any: PropTypes.any.description('Any'),
  union: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('Union'),
  union2: PropTypes.oneOf(['A', 'B']).description('Union 2'),
  union3: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({ string: PropTypes.string }),
  ]).description('Union 3'),
  array: PropTypes.arrayOf(PropTypes.string).description('Array'),
  object: PropTypes.object.description('Object'),
  shape: PropTypes.shape({
    string: PropTypes.string.description('String').isRequired,
    number: PropTypes.number.description('Number'),
    boolean: PropTypes.bool.description('Boolean'),
    anotherShape: PropTypes.shape({
      string: PropTypes.string.description('String').isRequired,
      number: PropTypes.number.description('Number'),
      boolean: PropTypes.bool.description('Boolean'),
    }).description('Another shape'),
  }).description('Shape'),
  function: PropTypes.func.description('Function'),
  jsx: PropTypes.element.description('JSX'),
  node: PropTypes.node.description('Node'),
  something: PropTypes.oneOf(['thing', 'object']).description('something'),
  isRequiredIf: PropTypes.string.description('isRequiredIf').isRequiredIf((props) => props.something === 'thing'),
  objectOf: PropTypes.objectOf(PropTypes.string).description('Object of'),
  objectOfArray: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).description('Object of array'),
};

const TestComponent = () => null;

const TestComponentWithSchema = describe(TestComponent).description('Test Component');

TestComponentWithSchema.propTypes = TestSchema;

export const TypescriptSchema = TestComponentWithSchema.toTypescript();
